// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JoTo","newExpiryDate":"styles_newExpiryDate__15hcl","footer":"styles_footer__1qSzd"};